import { domain } from "../auth/domain";
import swal from "sweetalert";

const getToken = () => localStorage.getItem("accessToken");

export async function getMonthlyGroupPerformance({ groupId, startDate, endDate, format = null }) {
  const token = getToken();
  if (!token) {
    throw new Error("No auth token found");
  }

  const queryParams = new URLSearchParams({
    group_id: groupId,
    start_date: startDate,
    end_date: endDate,
  });

  if (format) {
    queryParams.append("format", format);
  }

  const response = await fetch(`${domain}reports/monthly-group-performance/?${queryParams.toString()}`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  // If a format is requested, handle it as a file download
  if (format) {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `monthly_performance_report.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
    document.body.appendChild(a);
    a.click(); 
    a.remove();
    return { success: true, message: "Download started." };
  }

  // Otherwise, return JSON data
  return response.json();
}

export async function getMemberHealthScore(memberId) {
  const token = getToken();
  if (!token) {
    throw new Error("No auth token found");
  }

  const response = await fetch(`${domain}reports/member-health-score/${memberId}/`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export async function getGroupHealthScores(groupId) {
  const token = getToken();
  if (!token) {
    throw new Error("No auth token found");
  }

  const queryParams = new URLSearchParams({ group_id: groupId });

  const response = await fetch(`${domain}reports/group-health-scores/?${queryParams.toString()}`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export async function getGroupLiquidity(groupId) {
  const token = getToken();
  if (!token) {
    throw new Error("No auth token found");
  }

  const response = await fetch(`${domain}reports/group-liquidity/${groupId}/`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export async function getAuditComplianceLogs(params) {
  const token = getToken();
  if (!token) {
    throw new Error("No auth token found");
  }

  const queryParams = new URLSearchParams(params).toString();

  const response = await fetch(`${domain}reports/audit-compliance/?${queryParams}`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}

export async function getSystemGrowthMetrics(filters) {
  const token = getToken();
  if (!token) {
    throw new Error("No auth token found");
  }

  // Remove null/empty values before creating query params
  const validFilters = Object.fromEntries(
    Object.entries(filters).filter(([_, v]) => v != null && v !== "")
  );
  const queryParams = new URLSearchParams(validFilters).toString();

  const response = await fetch(`${domain}reports/system-growth-metrics/?${queryParams}`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}

export async function getAdminDashboardData() {
  const token = getToken();
  if (!token) {
    throw new Error("No auth token found");
  }

  const response = await fetch(`${domain}reports/admin-dashboard/`, {
    headers: {
      Authorization: `JWT ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
  }

  return response.json();
}